import React, { Component } from 'react';
import {connect} from 'react-redux';
import { CONFIG, URL_AKM } from '../../../../config';
import akmApi from '../../../../apis/akmApi';
import {cekCookies} from '../../../../actions';
import __ from 'lodash';
import {Row, Col, Alert, Modal} from 'react-bootstrap';
import LoaderModal from '../../../modal/LoaderModal';
import Navbar from '../../navbar/Navbar';
import Sidebar from '../../sidebar/Sidebar';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import Chip from '@material-ui/core/Chip';
import FaceIcon from '@material-ui/icons/Face';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Collapse from '@material-ui/core/Collapse';
import Checkbox from '@material-ui/core/Checkbox';
import MenuOpenIcon from '@material-ui/icons/MenuOpen';
import MenuIcon from '@material-ui/icons/Menu';
import Divider from '@material-ui/core/Divider';

class Menu extends Component {
    constructor(props) {
        super(props);
        this.state = {  
            isFetching: false,
            showAlert: false,
            resMessage: '',
            openModalUser: false,
            openModalmenu: false,
            menuList: [],
            roleList: [],
            userlist: [],
            selectedRole: {}
        }
    }

    async componentDidMount() {
        this.setState({ isFetching: true });          
        await this.props.cekCookies();    
        if(!__.isEmpty(this.props.account)){
            this.getRoles();
        }
        this.setState({ isFetching: false }); 
    }

    getRoles = async () => {        
        this.setState({ isFetching: true }); 
        const response = await akmApi.get(URL_AKM.GET_ROLE)
        .catch(function(error){ this.setState({showAlert:true, resMessage: error});});
        if(response){
            if(response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                this.setState({
                    roleList: response.data.data
                })
            } else {
                this.setState({
                    roleList: [], showAlert: true, resMessage: "Oopss Error, " + response.data.errorSchema.errorMessage
                })
            }
            this.setState({ isFetching: false }); 
        }
    }

    handleClickuser = async(idRole, namaRole) => {
        this.setState({ isFetching: true }); 
        const response = await akmApi.get(URL_AKM.GET_USER_BY_ROLE + idRole)
        .catch(function(error){ this.setState({showAlert:true, resMessage: error});});
        if(response){
            if(response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                this.setState({
                    userlist: response.data.data,
                    openModalUser: true,
                    selectedRole: {idRole: idRole, namaRole: namaRole}
                })
            } else {
                this.setState({
                    userlist: [], showAlert: true, resMessage: "Oopss Error, " + response.data.errorSchema.errorMessage,
                    openModalUser: false,
                    selectedRole: {}
                })
            }
            this.setState({ isFetching: false }); 
        }
    }

    handleClickMenu = async(idRole, namaRole) => {
        this.setState({ isFetching: true }); 
        const response = await akmApi.get(URL_AKM.GET_MENUS_BY_ROLE + idRole)
        .catch(function(error){ this.setState({showAlert:true, resMessage: error});});
        if(response){
            if(response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                this.setState({
                    menuList: response.data.data,
                    openModalmenu: true,
                    selectedRole: {idRole: idRole, namaRole: namaRole}
                })
            } else {
                this.setState({
                    menuList: [], showAlert: true, resMessage: "Oopss Error, " + response.data.errorSchema.errorMessage,
                    openModalmenu: false,
                    selectedRole: {}
                })
            }
            this.setState({ isFetching: false }); 
        }
    }

    renderModalUser() {
        const handleDelete = () => {
            window.confirm('Terminate this Faker ??')
        };
        return(
            <> 
            <Modal 
                show={this.state.openModalUser}
                onHide={() => this.setState({ openModalUser: false })}
                aria-labelledby="example-custom-modal-styling-title"
                size="lg" backdrop="static" keyboard={false}
            >
                <Modal.Header closeButton>
                <Modal.Title id="example-custom-modal-styling-title">
                    {this.state.selectedRole.namaRole} User :
                </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                {this.state.userlist.map((user,idx) =>
                <Chip key={idx} style={{margin: '5px'}}
                    icon={<FaceIcon />}
                    color="primary"
                    label={user.usernameAdmin}
                    onDelete={handleDelete}
                    variant="outlined"
                /> 
                )}
                </Modal.Body>
            </Modal>
            </>
        )
    }

    handlePost = async(data) => {
        this.setState({ isFetching: true }); 
        const response = await akmApi.post(URL_AKM.POST_ADD_SYS_MENU + this.state.selectedRole.idRole , data)
        .catch(function(error){ this.setState({showAlert:true, resMessage: error});});
        if(response){
            if(response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                const value = response.data.data
                console.log('data', data)
                console.log('response', value)
                if(value === null) {
                    const menus = [...this.state.menuList];
                    menus.map(d => {
                        if(d.menuCode === data.menuCode) {
                            d.id = null;
                        }
                        if(data.menuParent !== null) {
                            d.childMenu.map(c => {
                                if(c.menuCode === data.menuCode) {
                                    c.id = null;
                                }
                            })
                        }  
                    })
                    this.setState({ menuList: menus });
                } else {
                    const menus = [...this.state.menuList];                    
                    menus.map(d => {
                        if(d.menuCode === value.menuCode) {
                            d.id = value.id;
                        }
                        if(value.menuParent !== null) {
                            d.childMenu.map(c => {
                                if(c.menuCode === value.menuCode) {
                                    c.id = value.id;
                                }
                            })
                        }                        
                    })
                    this.setState({ menuList: menus });
                }
            } else {
                this.setState({
                    showAlert: true, resMessage: "Oopss Error, " + response.data.errorSchema.errorMessage
                })
            }
            this.setState({ isFetching: false }); 
        }
    }

    renderModalmenu() {
        const handleChekbox = (item) => () => { 
            this.handlePost(item);
        }
        return(
            <Modal
                show={this.state.openModalmenu}
                onHide={() => this.setState({ openModalmenu: false })}
                aria-labelledby="example-custom-modal-styling-title"
                size="lg" backdrop="static" keyboard={false}
            >
                <Modal.Header closeButton>
                <Modal.Title id="example-custom-modal-styling-title">
                    {this.state.selectedRole.namaRole} Menu List :
                </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                {this.state.menuList.map((menu,idx) =>
                <List key={idx}>
                    <ListItem>
                        <ListItemIcon>
                        <MenuOpenIcon />
                        </ListItemIcon>
                        <ListItemText ><span style={{fontWeight: '700'}}>{menu.label}</span></ListItemText>
                        <ListItemSecondaryAction>
                        <Checkbox
                            edge="end" color="primary"
                            onChange={handleChekbox(menu)}
                            checked={menu.id != null}
                            inputProps={{ 'aria-labelledby': 'checkbox-list-secondary-label-'+ menu.menuCode }}
                        />
                        </ListItemSecondaryAction>
                    </ListItem>                    
                    <Collapse in={true} timeout="auto" style={{paddingLeft: '20px' }}>
                    {menu.childMenu.map((child,i) =>
                        <List component="div" key={i}>
                        <ListItem >
                            <ListItemIcon>
                            <MenuIcon />
                            </ListItemIcon>
                            <ListItemText primary={child.label} />
                            
                        </ListItem>
                        <ListItemSecondaryAction>
                        <Checkbox
                            edge="end"
                            onChange={handleChekbox(child)}
                            checked={child.id != null}
                            inputProps={{ 'aria-labelledby': 'checkbox-list-secondary-label-'+ child.menuCode }}
                        />
                        </ListItemSecondaryAction>
                        </List>
                    )}
                    </Collapse>
                    <Divider light />
                </List>
                )}
                </Modal.Body>
            </Modal>
        )
    }

    render() {
        return (  
                <div className="wrapper">
                <LoaderModal isFetching={this.state.isFetching} />
                <Sidebar account={this.props.account}/>
                <div id="content" style={{paddingBottom: '50px'}}>
                    <Navbar title={'Setting Menu'} /> 
                    {this.renderAlert()}
                    <div className="container">
                        <ul className="list-group list-group-flush">
                            {this.state.roleList.map((item,key) => 
                                <li className="list-group-item" key={key}>
                                    <IconButton color="primary" title="info user..." component="span" onClick={() => this.handleClickuser(item.idRole, item.namaRole)}>
                                            <InfoOutlinedIcon />
                                        </IconButton>
                                    <span>{item.namaRole} ({item.kategoriOwner})</span>
                                    <div className="pull-right">                                        
                                        <i className="fa fa-ellipsis-v" aria-hidden="true"></i>
                                        <Button color="secondary"  onClick={() => this.handleClickMenu(item.idRole, item.namaRole)}>List Menu</Button>
                                    </div>
                                </li>
                            )} 
                        </ul>                        
                    </div>
                    
                </div>
                {this.renderModalUser()}
                {this.renderModalmenu()}
            </div>
        );
    }
    renderAlert = () => {
        const { showAlert,resMessage } = this.state;
      
        if (showAlert) {
          return (
            <Alert variant="info" onClose={() => this.setState({ showAlert: false })} dismissible>   
                <strong>{resMessage}</strong>
            </Alert>
          );
        } 
    }
}

const mapStateToProps = (state) => {
    return{
        account: state.account       
    };
}

export default connect(mapStateToProps, {cekCookies})(Menu); 